import { ContentContainer, GridBackground } from 'components/site'
import React from 'react'
import { Stack, Title } from '@mantine/core'
import classes from 'modules/Site/Pricing/index.module.scss'

const Header = () => {
  return (
    <GridBackground>
      <ContentContainer className={classes.wrapper}>
        <Stack align="center" className={classes.wrapper}>
          <Title className="text-[32px] pt-[124px] pb-[16px] sm:text-[56px] sm:pt-[145px] sm:pb-[70px]">
            选择合适你的最佳方案
          </Title>
        </Stack>
      </ContentContainer>
    </GridBackground>
  )
}

export default Header
